import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { RequestService } from 'src/app/consumer-immersions/request-list/service/request.service';
import { QualService } from 'src/app/qual/service/qual.service';

@Component({
  selector: 'app-view-ai-discussion-guid',
  templateUrl: './view-ai-discussion-guid.component.html',
  styleUrls: ['./view-ai-discussion-guid.component.scss']
})
export class ViewAiDiscussionGuidComponent implements OnInit {
  public discussionGuideInnerHtml: SafeHtml = "";
  public discussionGuideInnerHtmlArr: any[] = [];
  public uuid: any;
  public objective: string = '';
  constructor(
    public activeRout:ActivatedRoute, 
    public requestService:RequestService,
    private notifier:NotifierService,
    public QService:QualService,
    public sanitizer:DomSanitizer) { }

  ngOnInit(): void {
    this.activeRout.params.subscribe(params => {
          this.uuid = params['uuid'];
          if(this.uuid){
            setTimeout(()=>{
              this.getInterviewAiDiscussionGuide(this.uuid); 
            })
          }else{
            this.notifier.notify('error', 'Invalid Request ID');
          }
        });
  }

  // getInterviewAiDiscussionGuide(uuid){
  //       this.requestService.getAiDiscussionGuide(uuid).subscribe((response) => {
  //           if(response['status'] == 1){
  //               if(response['data'] && response['data']['misc'] && response['data']['misc']['discussion_guide']){
  //                   // this.discussionGuideInnerHtml = response['data']['misc']['discussion_guide'];
  //                   this.discussionGuideInnerHtml = this.sanitizer.bypassSecurityTrustHtml(response['data']['misc']['discussion_guide']);
  //               }
  //           }else{
  //               this.notifier.notify('error',response['errorMessage'] || 'Something went wrong.');
  //           }
  //       },error => {
  //           this.notifier.notify('error','Something went wrong.');
  //       });
  //   }

  getInterviewAiDiscussionGuide(uuid){
        this.requestService.getAiDiscussionGuide(uuid).subscribe((response) => {
            if(response['status'] == 1){
                if(response['data'] && response['data']['misc'] && response['data']['misc']['discussion_guide']){
                    this.discussionGuideInnerHtmlArr[0] = {"selected": true,objective:response['data']["objective"], "discussion_guide":response['data']['misc']['discussion_guide']};
                }
            }else{
                this.notifier.notify('error',response['errorMessage'] || 'Something went wrong.');
            }
        },error => {
            this.notifier.notify('error','Something went wrong.');
        });
    }

  generateAiDiscussionGuide(){
    if(!this.objective || this.objective.trim() === ''){
      this.notifier.notify('error', 'Objective cannot be empty');
    }else{
      if(this.requestService.isProcessingAIrequest){
      }else{
        let body = {
              "objective": this.objective,
              "ci_uuid": this.uuid,
              "job_id": this.requestService.jobId
          };
        // this.requestService.generateAiDiscussionGuide(body)
        this.QService.isLoading = true;
        this.requestService.isProcessingAIrequest = true;
        this.requestService.createAiDiscussionGuide(body).subscribe((responce) => {
            if(responce['status'] == 1){
                this.discussionGuideInnerHtmlArr.push({"selected": false, "objective": this.objective, "discussion_guide": responce['data']['discussion_guide']});
            }else{
                this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
            }
            this.QService.isLoading = false;
            this.requestService.isProcessingAIrequest = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.QService.isLoading = false;
            this.requestService.isProcessingAIrequest = false;
        });
      }
    }

  }
  
  getInnerHtml(discussion_guide:string) {
    var guideSafeInnerHtml:SafeHtml = this.sanitizer.bypassSecurityTrustHtml(discussion_guide);
    return guideSafeInnerHtml;
  }
  onSelectObjective(isSelected: boolean, guide) {
    this.discussionGuideInnerHtmlArr.forEach((item) => {
      item["selected"] = false; // Deselect all guides
    })
    guide["selected"] = isSelected;
    this.objective = guide.objective;
    let body = {
      "uuid": this.uuid,
      "misc": {"objective": this.objective,"discussion_guide": guide.discussion_guide || ''},
    };
    this.updateInterviewDiscussionGuide(body);
  }
  updateInterviewDiscussionGuide(body){
    this.QService.isLoading = true;
    this.requestService.updateInterviewAiDiscussionGuide(body).subscribe((responce) => {
            if(responce['status'] == 1){
                this.notifier.notify('success',responce['message'] || 'Updated successfully.');
            }else{
                this.notifier.notify('error',responce['errorMessage'] || 'Something went wrong.');
            }
            this.QService.isLoading = false;
        },error => {
            this.notifier.notify('error','Something went wrong.');
            this.QService.isLoading = false;
        });

  }
  copyDiscussionGuide(className: string) {
    const contentDiv = document.querySelector('.'+className) as HTMLElement;
    // Use the Range API to get the content of the div
    const range = document.createRange();
    range.selectNodeContents(contentDiv);
    // Use a temporary selection to copy the content
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
    try {
      // Execute the copy command
      const successful = document.execCommand('copy');
      if (successful) {
        this.notifier.notify('success','copied to clipboard!')
      } else {
        this.notifier.notify('error','Copy failed.')
      }
    } catch (err) {
      this.notifier.notify('error','Something went wrong while copying')
    }
    // Deselect the content after copying
    selection?.removeAllRanges();
  }
}
